import { createFileRoute } from "@tanstack/react-router";

import { InboundCallsDashboard } from "../tools/dashboards/InboundCallsDashboard";

function InboundCallsRoute() {
  return <InboundCallsDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/inbound-calls")({
  component: InboundCallsRoute,
});
